import React from "react";
import { useParams } from "react-router-dom";
import Typography from "@components/Typography";
import { getIconPath, getMarketPairDisplay } from "@core/utils/getCurrencyMeta";
import useStyles from "./styles";

const ShowCurrentCurrency = () => {
  const classes = useStyles();
  const { currencyName } = useParams();
  const { base, baseName, quoteName, baseUnit, quoteUnit } =
    getMarketPairDisplay(currencyName);
  return (
    <div className={classes.currencySelect}>
      <div className={classes.currencyContainer}>
        <img
          src={getIconPath(base)}
          className={classes.currencyImage}
        />
        <div className={classes.currencyText}>
          <Typography isBold>{baseName}</Typography>
          /{" "}
          <Typography isBold>
            {" "}
            {quoteName}
          </Typography>
        </div>
        <div className={classes.currencyText}>
          <Typography color="secondary.tint40">
            ({baseUnit}/
          </Typography>
          <Typography color="secondary.tint40">
            {" "}
            {quoteUnit})
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ShowCurrentCurrency;
